import { useField } from "formik";
import DropdownAutoComplete from "../DropdownAutoComplete";
import { checkFormValidity } from "../../../src/utils/helpers";
import React, { useState, useEffect } from "react";
import { WorkflowErrors } from "../../contexts/WorkflowErrors";

export default function (props) {
  const { options, onChange, name, label, value } = props;
  const [field, meta, helper] = useField(props);
  const touchedError = meta.touched && meta.error;
  const [taskErrors, setTaskErrors] = React.useContext(WorkflowErrors);

  const handleChange = (event, value) => {
    helper.setValue(value);
  };

  if (field?.value && typeof field.value !== "object") {
    const result = options.find((option) => option.value === field.value) ?? "";
    handleChange(null, result);
  }

  useEffect(() => {
    // function to check the validity of the field
    checkFormValidity(field, meta, props, taskErrors, setTaskErrors);
  }, [field, meta, props]);

  const propsObj = { ...props };
  delete propsObj.taskReferenceName;

  return (
    <DropdownAutoComplete
      {...propsObj}
      {...field}
      onChange={(e, value) => handleChange(e, value)}
      error={touchedError}
      helperText={touchedError}
    />
  );
}
